"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBox = void 0;
var Utilities_1 = require("../../Utilities");
var SearchBox_base_1 = require("./SearchBox.base");
var SearchBox_styles_1 = require("./SearchBox.styles");
exports.SearchBox = (0, Utilities_1.styled)(SearchBox_base_1.SearchBoxBase, SearchBox_styles_1.getStyles, undefined, { scope: 'SearchBox' });
//# sourceMappingURL=SearchBox.js.map